import React from 'react';
import ProfileSectionNudgeCard from './index';
import { useProfileSectionNudge } from '../../hooks/useProfileSectionNudge';

const ProfileSectionNudgeHost: React.FC = () => {
  const nudge = useProfileSectionNudge();

  if (!nudge) {
    return null;
  }

  return <ProfileSectionNudgeCard nudge={nudge} onDismiss={nudge.dismiss} />;
};

export default ProfileSectionNudgeHost;
